import { motion } from "framer-motion";
import { Building2, ShieldCheck, Clock3, Users } from "lucide-react";

const FEATURES = [
  { icon: Building2, title: "Real Estate Focused", desc: "We understand property marketing, luxury hooks and what actually sells in Dubai's market." },
  { icon: ShieldCheck, title: "Trakheesi-Ready", desc: "We add permit numbers and QR codes as required, so your ads stay compliant and never get pulled." },
  { icon: Clock3, title: "Dubai-Hours Delivery", desc: "We work when you work. Early overlap with GST business hours and responsive communication." },
  { icon: Users, title: "Reliable Creative Squad", desc: "Experienced designers and video editors on your account — not a rotating pool of freelancers." },
];

export const WhyUs = () => {
  return (
    <section id="why-us" data-testid="why-us-section" className="py-16 sm:py-24 lg:py-28 bg-[#0b1426]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="max-w-2xl"
        >
          <p className="font-code text-xs sm:text-sm uppercase tracking-[0.25em] text-[#fba31b] font-bold">Why Webastra</p>
          <h2 className="font-display mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">
            More Than Just <span className="text-[#fba31b]">Designers and Editors</span>
          </h2>
          <p className="mt-4 text-slate-300 text-base sm:text-lg">
            Your creative partner built for the real estate industry — reliable, compliant and obsessed with conversion.
          </p>
        </motion.div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {FEATURES.map((f, i) => (
            <motion.div
              key={f.title}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.55, delay: i * 0.1 }}
              data-testid={`why-us-card-${i + 1}`}
              className="card-hover rounded-3xl bg-[#162544] border border-white/10 p-7"
            >
              <div className="w-12 h-12 rounded-xl bg-[#fba31b]/12 border border-[#fba31b]/30 flex items-center justify-center">
                <f.icon className="w-6 h-6 text-[#fba31b]" />
              </div>
              <h3 className="mt-5 font-display text-lg font-bold">{f.title}</h3>
              <p className="mt-2.5 text-sm text-slate-400 leading-relaxed">{f.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
